import React, { useEffect, useState } from "react";
import general from "../../../general";
import { Link } from "react-router-dom";
import $ from "jquery";
import { useUpdateEffect, useScroll } from "ahooks";
import Dialog from "../../../lib/Dialog";
import Image from "../../../lib/Image";
import dayjs from "dayjs";
import { splitStr } from "../../../utils/commonFunc";

export default (props) => {
  const [init, setInit] = useState();
  const [loading, setLoading] = useState();
  const [page, setPage] = useState(1);
  const [games, setGames] = useState([]);
  const [more, setMore] = useState(true);
  const load = (parms = {}) => {
    if (loading) {
      return;
    }
    setLoading(true);
    Dialog.loading();
    let tmp = {
      pagination: { page: page },
    };
    if (parms.page) {
      tmp.pagination = { page: parms.page };
    }
    general.axios
      .post("/v3/reservedGames", tmp)
      .finally(() => {
        setLoading(false);
        Dialog.close();
      })
      .then((response) => {
        setInit(true);
        let result = response.data.data;
        if (parms.page) {
          setPage(parms.page);
        }
        setGames((games) =>
          parms.page === 1 || !parms.page
            ? result.game_list
            : [...games, ...result.game_list]
        );
        setMore(result.paginated.more);
      })
      .catch((error) => {
        Dialog.error(error.message);
      });
  };
  useEffect(() => {
    if (props.active && !init) {
      load();
    }
  }, [props.active]);
  useUpdateEffect(() => {
    if (props.active && (!init || props.action === "POP")) {
      load();
    }
  }, [props.action]);

  const scroll = useScroll();
  useEffect(() => {
    if (props.active && init) {
      if (scroll?.top < -80) {
        load({ page: 1 });
      }
      if (
        scroll?.top + window.innerHeight + 20 > $(document).height() &&
        more
      ) {
        load({ page: page + 1 });
      }
    }
  }, [scroll, props.active]);

  return (
    <>
      <div className="ug-main">
        {games.length ? (
          <>
            <div className="ug-game">
              {games.map((game) => (
                <Link
                  key={game.game_id}
                  to={"/game?id=" + game.game_id}
                  className="item"
                >
                  <div className="body">
                    <div className="icon">
                      <Image src={game.game_image.thumb} />
                    </div>
                    <div className="data">
                      <div className="name">
                        {game.game_name_main || game.game_name}
                      </div>

                      <div
                        className="desc"
                        style={{ justifyContent: "flex-start" }}
                      >
                        {splitStr(game.game_classify_type)}
                        {game.game_name_branch ? (
                          <div style={{ display: "inline" }}>
                            {" "}
                            · {game.game_name_branch}
                          </div>
                        ) : null}
                      </div>

                      <div className="desc">
                        {dayjs.unix(game.reserved_time).format("MM-DD HH:mm")}{" "}
                        预约过
                        <div className="special">
                          {dayjs.unix(game.starting_time).format("MM-DD HH:mm")}{" "}
                          首发
                        </div>
                      </div>
                    </div>
                  </div>
                </Link>
              ))}
              {games.length > 0 && !more ? (
                <div className="view-end">别撩啦！已经到底啦~</div>
              ) : null}
            </div>
          </>
        ) : null}
        {init && !games.length ? (
          <>
            <div className="ug-empty">
              <img style={{ width: "40%" }} src="/resources/empty.png" alt="" />
              <p>
                您还没有预约过游戏，看看下面的游戏
                <br />
                有没有你喜欢的吧
              </p>
            </div>
          </>
        ) : null}
      </div>
    </>
  );
};
